<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder">
              <PaymentForm class="form-horizontal">
                <FormSection title="Gift Frequency">
                    <DonationFrequency />
                  </FormSection>
                  <FormSection title="Select Gift Amount">
                      <FormRow inline>
                          <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/>
                      </FormRow>
                      <AmountSelector/>
                      <ErrorLabel field="amount" />
                      <TransactionFee />
                  </FormSection>
    
                  <FormSection title="Your Details">
                      <FormRow inline>
                          <FormCol field="title" :flex="1" />
                          <FormCol field="firstName" :flex="2" />
                          <FormCol field="lastName" :flex="2" />
                      </FormRow>
                      <FormRow inline>
                          <FormCol field="email" />
                          <FormCol field="phone" />
                      </FormRow>
                      <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
                  </FormRow> 
                  </FormSection>
                  <FormSection title="Billing Information">
                      <DonorAddress />
                  </FormSection>
                  <FormSection title="Dedication and Designation">
                    <InHonorOf />
                  </FormSection>
                  <FormSection title="Payment Information" last>
                    <FormRow>
                      <Receipt />
                    </FormRow>
                      <FormRow inline>
                          <FormCol field="card" :showLabel="false"/>
                      </FormRow>
                  </FormSection>
                  <PaymentButton showAmount btnText="Donate"/>
              </PaymentForm>
          </div>
      </div>
  </div>
  </template>

  <script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  components: {},
  setup(props) {
    const { form, setValue } = usePaymentForm();

    setValue('gateway', 'SensePassCardknox')


    return {
      form,
      setValue,
    };
  },
});
</script>


  <style scoped lang="scss">
  h2.payment-heading {
    display: flex;
    justify-content: space-between;
  }
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }
  .fee-total {
    margin-bottom: 0;
    justify-content: space-between;
  }
  .other-means {
    font-size: 14px;
    line-height: 1.6;
  }
  ::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
    min-width: 23%;
    max-width: 23%;
    &:nth-child(6n) {
      padding-right: 10px;
    }
  }
  .control-label {
    font-size: 14px;
    color: #222;
  }
  </style>
  
  